import React from "react";
import { useTranslation } from "react-i18next";
import TitleSection from "../components/TitleSection/TitleSection";
import DescriptionBox from "../components/DescriptionBox";
import ServiceList from "../components/ServiceList";
import ContactFormPages from "../components/ContactFormPages";
import { Images } from "../assets";

const Hydraulique = () => {
  const { t } = useTranslation();

  const hydrauliqueServices = [
    { text: t("hydraulique.services.revision") },
    { text: t("hydraulique.services.honnage") },
    { text: t("hydraulique.services.rechromage") },
    { text: t("hydraulique.services.fabrication") },
    { text: t("hydraulique.services.stockJoints") },
    { text: t("hydraulique.services.sertissage") },
    { text: t("hydraulique.services.stockRaccords") },
  ];

  const hydrauliqueDescription = [
    t("hydraulique.description.experience"),
    t("hydraulique.description.atelier"),
    t("hydraulique.description.stock"),
    t("hydraulique.description.sertisseuse"),
  ];

  return (
    <>
      <TitleSection
        title={t("hydraulique.title")}
        subtitle={t("hydraulique.subtitle")}
        highlightWords={[
          t("hydraulique.highlightWords.pressureFluids"),
          t("hydraulique.highlightWords.industrialMachines"),
        ]}
        bgImg={Images.HYDRAULIQUE_BG_IMAGE}
      />

      <div className="flex flex-col gap-14 mx-5 md:mx-10 my-14">
        <section className="flex flex-col gap-5 md:flex-row">
          <DescriptionBox
            title={t("hydraulique.descriptionTitle")}
            content={hydrauliqueDescription}
          />
          <ServiceList
            title={t("hydraulique.servicesTitle")}
            services={hydrauliqueServices}
          />
        </section>
      </div>

      <ContactFormPages />
    </>
  );
};

export default Hydraulique;
